<template>
  <div class="patient_with_chat_box">
    <div class="patient_with_chat_box_inner_wrp">
      <div class="patient_with_chat_box_header">
        <div class="row align-items-center">
          <div class="col">
            <div class="row align-items-center" v-if="patientInfo">
              <div class="col-auto pr-3">
                <span class="consult_patient_avatar" style="position: relative;">
                  <span class="prfl_avatar_lazy_load_box">
                    <template v-if="patientInfo.user.profile.thumbnail">
                      <img :src="patientInfo.user.profile.thumbnail" class="img-fluid">
                      <img :src="patientInfo.user.profile.avatar" v-if="patientInfo.user.profile.avatar"
                        class="img-fluid">
                    </template>
                    <template v-else>
                      <img src="@/assets/images/user_default.png" class="img-fluid">
                    </template>
                  </span>
                  <i class="online-status" :class="patientInfo.is_online ? 'available' : ''"></i>
                </span>
              </div>
              <div class="col pl-0">
                <span class="consult_patient_name">{{ patientInfo.full_name }}</span>
                <template v-if="typingUserInfoState">
                  <span class="typing_info_text" v-if="patientInfo.chat_room_id == typingUserInfoState.ChatRoomId">
                    Typing...
                  </span>
                </template>
                <template v-else>
                  <span class="usr_status_label available" v-if="patientInfo.is_online">Online</span>
                  <span class="usr_status_label" v-else>Offline</span>
                </template>
              </div>
            </div>
          </div>
          <div class="col-auto text-right">
            <template v-if="patientInfo.is_online">
              <button v-if="callTextState" class="btn btn-primary calling_txt_btn">
                Calling...
              </button>
              <button class="btn btn-primary"
                @click="videoCallRequestFun(patientInfo.user.id, patientInfo.chat_room_id)" v-else>
                Video Call
              </button>
            </template>
            <template v-else>
              <button class="btn btn-primary disabled" disabled>
                Video Call
              </button>
            </template>
            <button class="btn btn-danger ml-3" @click="chatClosedMethod">Close Chat</button>
          </div>
        </div>
      </div>
      <div class="patient_with_chat_box_body">
        <div class="patient_chat_msg_list_wrp" id="chat_msg_list_scroll">
          <div class="extra_pchat_space"></div>
          <div id="list_of_patient_chat_msg_wrp">
            <template v-if="patientChatDetails">
              <div class="list_msg_of_patient_chat">
                <ul>
                  <li class="pchatmsg" v-for="(item, index) in reversedChatListResults" :id="'chatMessageId' + item.id"
                    :key="item.id">
                    <div
                      v-if="index === 0 || formatDateSeparator(reversedChatListResults[index].timestamp) !== formatDateSeparator(reversedChatListResults[index - 1].timestamp)"
                      class="msg_date_wrp">
                      <span class="msg_date_box">
                        {{ formatDateSeparator(item.timestamp) }}
                      </span>
                    </div>
                    <div :class="item.sender.user_id == selfUserId ? 'pchatmsg_recieved' : 'pchatmsg_sent'">
                      <div class="pchat_msg_item"
                        :class="item.sender.user_id == selfUserId ? 'pchat_recieved_msg' : 'pchat_send_msg'">
                        {{ item.decrypted_content }}
                        <span class="msg_time_wrp" v-if="item">
                          <time v-if="item.timestamp" class="msg_time">{{ item.timestamp | chattimeformat }}</time>
                        </span>
                        <label class="message_indication_label" v-if="item.sender.user_id == selfUserId">
                          <template v-if="messagesIndicationStatusMethod(item.message_statuses) == 'read'">
                            <i class="msg_indicated_dot read" aria-hidden="true"></i>
                          </template>
                          <template v-else-if="messagesIndicationStatusMethod(item.message_statuses) == 'delivered'">
                            <i class="msg_indicated_dot sent" aria-hidden="true"></i>
                          </template>
                          <template v-else>
                            <i class="msg_indicated_dot unsent" aria-hidden="true"></i>
                          </template>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <div class="compontent-loader pt-0 pb-5" v-else>
              <div class="spinner"></div>
            </div>
          </div>
          <template v-if="typingUserInfoState">
            <div class="typing_dots_wrp" v-if="patientInfo.chat_room_id == typingUserInfoState.ChatRoomId"
              style="padding:0px 35px">
              <img src="@/assets/images/loading_dots.gif" height="30">
            </div>
          </template>
        </div>
      </div>
      <div class="patient_with_chat_box_footer">
        <div class="message_input_wrp">
          <textarea type="text" autocomplete="off" id="chat-message-reply-input" placeholder="Type a message..."
            v-if="selection_type == 'click_send'" class="click_send"></textarea>
          <textarea type="text" autocomplete="off" id="chat-message-reply-input" placeholder="Type a message..."
            @keydown.enter.exact.prevent @keyup.enter.exact="send" @keydown.enter.shift.exact="newline" v-else
            class="press_enter"></textarea>
          <div class="option_btn_wrp">
            <button id="chat-message-reply-submit" class="submit"><svg width="57px" height="54px"
                viewBox="1496 193 57 54" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 18px; height: 18px;">
                <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                  transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                  <path data-v-77c07480=""
                    d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                    id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/services/commonSocket";
import moment from 'moment';

export default {
  name: 'chat-of-patient',
  components: {},
  props: ['patientInfo'],
  data() {
    return {
      selfUserId: '',
      selfUserInfo: null,
      patientChatDetails: null,
      patientChatDetailResults: [],
      selection_type: 'press_enter',
      callTextState: false,
      typingUserInfoState: null,
      doctorInfo: null,
      patientChatScoket: null,
      msgNextPageLoader: '',
      lastLiveMsgData:null
    }
  },
  computed: {
    reversedChatListResults() {
      return [...this.patientChatDetailResults].reverse();
    },
  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID');
      this.selfUserInfo = JSON.parse(localStorage.getItem('LoginedUserInfo'));
    }

    if (this.patientInfo) {
      this.doctorInfo = this.patientInfo.doctor_detail;
      this.createRoomWithPatient(this.patientInfo.chat_room_id);
    }

    bus.$on('userUpdateStatus', (data) => {
      let user = this.patientInfo.id == data.userID;
      if (user) {
        this.patientInfo.is_online = data.is_online;
      }
    });

    bus.$on('typingEventForChatBus', (data) => {
      this.typingUserInfoState = data;
      if (data.message == 'stop') {
        this.typingUserInfoState = null;
      }
    });

    this.handleMessageLoader();
  },
  methods: {
    /*
     * This Will Video Call Request Function
    */
    videoCallRequestFun(callerId, roomId) {
      this.callTextState = true;
      let callerFullName = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name;
      commonSocketConnectMethod.emit({
        callerName: callerFullName,
        type: "videoCalling",
        callerID: this.selfUserId,
        targetId: callerId,
        roomId: roomId
      });
      commonSocketConnectMethod.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      commonSocketConnectMethod.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      commonSocketConnectMethod.$on('videoCallAlertPopupClosed', this.notrecievedCall);
      commonSocketConnectMethod.$on('autoMissedCallEvent', this.autoMissedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserId == getAnswerData.targetId) {
        this.$router.push('/video/conference/#' + getAnswerData.roomId);
      }
      this.callTextState = false;
    },
    getDeclinedOfVideoCall() {
      this.callTextState = false;
    },
    notrecievedCall() {
      this.callTextState = false;
    },
    autoMissedCall() {
      this.callTextState = false;
    },
    messagesIndicationStatusMethod(item) {
      if (!item) return;
      const allRead = item.every(status => status.is_read);
      const allDelivered = item.every(status => status.is_delivered);
      if (allRead) {
        return 'read';
      } else if (allDelivered) {
        return 'delivered';
      } else {
        return 'undelivered';
      }
    },
    formatDateSeparator(timestamp) {
      const date = new Date(timestamp);
      const options = { month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    handleMessageLoader() {
      const elmntList = document.getElementById("chat_msg_list_scroll");
      if (!elmntList) return;
      elmntList.addEventListener("scroll", () => {
        if (elmntList.scrollTop === 0) {
          if (this.msgNextPageLoader) {
            axios.get(this.msgNextPageLoader)
              .then((response) => {
                if (response.status === 200 && response.data && response.data.data) {
                  const { next, results } = response.data.data;
                  const previousScrollHeight = elmntList.scrollHeight;

                  this.msgNextPageLoader = next;
                  this.patientChatDetailResults = [...this.patientChatDetailResults, ...results];

                  this.$nextTick(() => {
                    elmntList.scrollTop = elmntList.scrollHeight - previousScrollHeight;
                  });
                }
              })
              .catch((err) => {
                console.error("Error loading older messages:", err);
              });
          }
        }
      });
    },

    newline() { },
    send() { },

    enabledYearDateFun(msgDateTime) {
      var currentLocalDate = moment().format('YYYY');
      var startDateCheck = moment(msgDateTime).format('YYYY')
      if (currentLocalDate > startDateCheck) {
        return true;
      } else {
        return false;
      }
    },

    createRoomWithPatient(createdRoomChatId) {
      const authToken = localStorage.getItem('token');

      this.$store.dispatch('getChatRoomDetailForPatientMethod', { id: createdRoomChatId })
        .then(response => {
          const { data } = response.data;
          this.patientChatDetails = data;
          this.patientChatDetailResults = [].concat(data.results);
          this.msgNextPageLoader = data.next;
          this.chatScrollAlwaysBottomMethod();

          this.setupChatSocket(createdRoomChatId, authToken);
        })
        .catch(error => {
          console.error('Failed to get chat room details:', error);
        });
    },

    setupChatSocket(roomId, token) {
      const messagesList = document.getElementById('list_of_patient_chat_msg_wrp');

      this.patientChatScoket = new WebSocket(
        `wss://${process.env.VUE_APP_WEBSOCKET_BASE_URL}/ws/chat/${roomId}/?token=${token}`
      );

      const messageInput = document.querySelector('#chat-message-reply-input');
      const sendButton = document.querySelector('#chat-message-reply-submit');

      messageInput.focus();

      messageInput.addEventListener('keydown', (event) => {
        if (this.selection_type === 'press_enter' && event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          sendButton.click();
        } else {
          commonSocketConnectMethod.emit({
            type: "TypingEventForChat",
            message: 'typing',
            ChatRoomId: roomId
          });
          clearTimeout(this.typingTimeout); // Clear previous timeout using component property
          this.typingTimeout = setTimeout(() => { // Assign to component property
            commonSocketConnectMethod.emit({
              type: "TypingEventForChat",
              message: 'stop',
              ChatRoomId: roomId
            });
          }, 2000);
        }
      });

      sendButton.addEventListener('click', () => {
        const message = messageInput.value.trim();

        if (message) {
          const payload = {
            chatRoomId: roomId,
            message: message,
            senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
          };
          this.patientChatScoket.send(JSON.stringify({
            type: 'chat_message',
            message: {
              content: message,
            }
          }));
          commonSocketConnectMethod.emit({
            type: "TypingEventForChat",
            message: 'stop',
            ChatRoomId: roomId
          });
          bus.$emit('newChatMessage', payload);
          messageInput.value = '';
        }
      });

      this.patientChatScoket.onmessage = (event) => {
        const data = JSON.parse(event.data);   
        if(data.type == 'readStatus') {
          if(this.lastLiveMsgData){
              this.allMessageListMethod();
          }
           return;
        }else{
          this.appendMessage(data, messagesList, this.selfUserId);
        }
      };

      this.patientChatScoket.onclose = (event) => {
        console.error("Socket Closed", event);
      };

      bus.$on('socketClosedNotifications', () => {
        this.chatClosedMethod();
      });

      this.$nextTick(() => {
        this.chatScrollAlwaysBottomMethod();
      });
    },

    appendMessage(data, messagesList, selfUserId) {
      const isSelfMessage = data.sender.user_id == selfUserId;
      const messageContainer = document.createElement("div");
      const messageItem = document.createElement("div");
      const timeWrapper = document.createElement("span");
      const timeElement = document.createElement("time");
      const formattedTime = moment(data.timestamp).format('h:mm a');

      // Use a single line to set multiple attributes and class names
      messageContainer.className = `append_pchatmsg ${isSelfMessage ? 'pchatmsg_recieved' : 'pchatmsg_sent'}`;
      messageItem.className = `pchat_msg_item ${isSelfMessage ? 'pchat_recieved_msg' : 'pchat_send_msg'}`;
      timeWrapper.className = 'msg_time_wrp';
      timeElement.className = 'msg_time';

      messageItem.textContent = data.decrypted_content;
      timeElement.textContent = formattedTime;

      timeWrapper.appendChild(timeElement);
      messageItem.appendChild(timeWrapper);
      messageContainer.appendChild(messageItem);

      if (isSelfMessage) {
        messageItem.appendChild(this.createReadStatusLabelMethod(data));
      }
      messagesList.appendChild(messageContainer);
      this.chatScrollAlwaysBottomMethod();
    },

    createReadStatusLabelMethod(data) {
      this.lastLiveMsgData = data;
      const labelReadS = document.createElement("label");
      labelReadS.classList.add('message_indication_label');
      const labelReadI = document.createElement("i");
      labelReadI.classList.add('msg_indicated_dot');
      const liveMsgs = document.querySelectorAll('#messages .msg_indicated_dot');
      const apiMsgs = document.querySelectorAll('#append_message .msg_indicated_dot');
      if (this.messagesIndicationStatusMethod(data.message_statuses) == 'read') {
        labelReadI.setAttribute("class", 'msg_indicated_dot read');
        // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
        apiMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
      } else if (this.messagesIndicationStatusMethod(data.message_statuses) == 'delivered') {
        labelReadI.setAttribute("class", 'msg_indicated_dot sent');
        // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
            element.classList.remove('unsent');
            element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
        apiMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
            element.classList.remove('unsent');
            element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
      } else {
        labelReadI.setAttribute("class", 'msg_indicated_dot unsent');
      }
      labelReadS.appendChild(labelReadI);
      return labelReadS;
    },

    chatScrollAlwaysBottomMethod() {
      const elmnt = document.getElementById("chat_msg_list_scroll");
      if (elmnt) {
        elmnt.scrollTop = elmnt.scrollHeight;
      }
    },

    /*
     * this will get All Message List again
    */
    allMessageListMethod() {
      this.$store.dispatch('getChatRoomDetailForPatientMethod', { id: this.patientInfo.chat_room_id})
        .then(response => {
          const { data } = response.data;
          this.patientChatDetails = data;
          this.patientChatDetailResults = [].concat(data.results);
          this.msgNextPageLoader = data.next;
          // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
          if ($ && typeof $.fn.remove === 'function') {
            $('.append_pchatmsg').remove();
          } else {
            // console.warn("jQuery not available or .remove() not a function. Cannot remove '.append_pchatmsg' elements.");
            document.querySelectorAll('.append_pchatmsg').forEach(el => el.remove());
          }
          this.lastLiveMsgData = null; // Reset lastLiveMsgData to null
        })
    },

    chatClosedMethod() {
      if (this.patientChatScoket && this.patientChatScoket.readyState === WebSocket.OPEN) {
        this.patientChatScoket.close();
      }
      bus.$emit('chatInitWithPatientBus', true);
    },
  },
  beforeDestroy() {
    this.chatClosedMethod();
    // document.getElementById("chat_msg_list_scroll").removeEventListener("scroll", this.handleMessageLoader);
  },
}
</script>

<style lang="scss" scoped>
.patient_with_chat_box {
  position: relative;
  border: 1px solid #232323;

  .typing_info_text {
    font-size: 14px;
    color: #00de09;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    display: block;
    line-height: 1;
  }

  .patient_with_chat_box_header {
    background: #111111;
    padding: 10px 15px;
  }

  .consult_patient_avatar {

    // width: 40px;
    // border-radius: 50%;
    // height: 40px;
    // -o-object-fit: cover;
    // object-fit: cover;
    // -o-object-position: top center;
    // object-position: top center;
    .prfl_avatar_lazy_load_box {
      position: relative;
      width: 40px;
      height: 40px;
      overflow: hidden !important;
      border-radius: 50%;
      border: 2px solid #c4c4c4;
      display: inline-block;
    }
  }

  .consult_patient_name {
    color: #ffffff;
    line-height: 1;
    font-size: 20px;
  }

  .patient_with_chat_box_body {
    min-height: calc(100vh - 302px);
    max-height: calc(100vh - 302px);
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    position: relative;
  }

  .message_input_wrp {
    display: flex;

    textarea {
      font-family: "proxima-nova", "Source Sans Pro", sans-serif;
      border: none;
      width: calc(100% - 50px);
      padding: 10px 22px;
      font-size: 15px;
      color: #fff;
      background: #111;
      line-height: 1.3;
      height: 70px;
      outline: none;
      resize: none;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    button {
      background: #232323;
      color: #ffffff;
      height: 100%;
      border: none;
      width: 100%;

      &:hover {
        background: #87cefa;
        color: #000;
      }

      &:hover path {
        fill: #000000;
      }
    }

    .option_btn_wrp {
      width: 50px;
    }
  }

  .patient_chat_msg_list_wrp {
    position: absolute;
    top: 0;
    z-index: 100;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 8px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #333333;
    }
  }

  .extra_pchat_space {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }

  .list_msg_of_patient_chat {
    ul {
      margin: 0px;
      padding: 0;
      list-style-type: none;
      width: 100%;
      // display: flex;
      // align-items: center;
      // flex-direction: column-reverse;

      li {
        width: 100%;
        padding: 5px 0;

        .pchatmsg_recieved {
          text-align: right;
        }
      }
    }

    .pchat_msg_item {
      position: relative;
      display: inline-block;
      padding: 5px 10px;
      word-break: break-word;
      white-space: normal;
      font-weight: 500;

      &:after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
      }

      &.pchat_recieved_msg {
        background: #ffb6c1;
        color: #000;
        border-radius: 7px 0px 7px 7px;

        &:after {
          border-width: 0px 0 8px 6px;
          border-color: transparent transparent transparent #ffb6c1;
          top: 0;
          right: -5px;
        }
      }

      &.pchat_send_msg {
        background: #b1d4e5;
        color: #000;
        border-radius: 0px 7px 7px 7px;

        &:after {
          border-width: 0px 6px 8px 0;
          border-color: transparent #b1d4e5 transparent transparent;
          top: 0;
          left: -5px;
        }
      }

      .msg_time_wrp {
        display: block;
        text-align: right;
        text-transform: uppercase;
        margin-top: 2px;
        line-height: 1;
        font-size: 10px;

        .msg_time {
          font-size: 10px;
          line-height: 1;
          color: rgba(0, 0, 0, 0.5);
          font-weight: 500;
          display: inline-block;
          vertical-align: middle
        }
      }
    }
  }

  .btn-danger {
    font-family: 'AceSansDemo';
    font-size: 17px;
    background: #ff3a30;
    border: none !important;
    padding: 8px 10px;
    line-height: 1;
    outline: none !important;
    box-shadow: none !important;

    @media only screen and (max-width:767px) {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .btn-primary {
    padding: 10px 30px !important;
    font-size: 17px;
    border-radius: 50px;
    background: none !important;
    color: #ffd400 !important;
    border: none;
    text-transform: capitalize;
    font-weight: 400;
    letter-spacing: .03em;
    line-height: 1;
    transition: all .5s ease;
    -webkit-transition: all .5s ease;
    -moz-transition: all ease .5s;
    box-shadow: none !important;
    outline: none;
    border: 2px solid #ffd400 !important;
    font-weight: 500;

    &:hover {
      background: #ffd400 !important;
      color: #000000 !important;
    }

    @media only screen and (max-width:767px) {
      padding: 7px 20px !important;
      font-size: 16px;
    }
  }

  .msg_date_wrp {
    text-align: center;
    margin: 15px 0;
    position: relative;

    &:before {
      content: "";
      height: 1px;
      background: hsla(0, 0%, 100%, .28);
      position: absolute;
      left: -25px;
      right: -25px;
      top: 50%;
      transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
    }

    span.msg_date_box {
      background: #ffc107;
      color: #000;
      border-radius: 3px;
      padding: 2px 6px !important;
      z-index: 100;
      font-weight: 500;
      font-size: 15px;
      line-height: 1;
      position: relative;
    }
  }

  #reply_msg_list {
    padding: 10px 35px;

    @media only screen and (max-width:767px) {
      padding: 10px 25px;
    }
  }

  #list_of_patient_chat_msg_wrp {
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    // -ms-flex-wrap: wrap;
    // flex-wrap: wrap;
    // -webkit-box-flex: 1;
    // -ms-flex-positive: 1;
    // flex-grow: 1;
    // -webkit-box-orient: vertical;
    // -webkit-box-direction: reverse;
    // -ms-flex-direction: column-reverse;
    // flex-direction: column-reverse;
    padding: 10px 35px;
  }

  .fixloader.msgloader {
    position: absolute;
    top: 0;
    width: 150px;
    height: 70px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: #000000;
    z-index: 100;
  }

  .fixloader.msgloader .spinner {
    width: 65px;
    height: 65px;
  }

  .fixloader.msgloader .spinner::after {
    width: 35px;
    height: 35px;
  }

  .fixloader.msgloader .spinner::before {
    width: 65px;
    height: 65px;
  }

  .online-status {
    position: absolute;
    left: 25px;
    bottom: 3px;
    border: 1px solid #9E9E9E;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background: #9E9E9E;

    &.available {
      background-color: #38b124;
      border-color: #38b124;
    }
  }

  .usr_status_label {
    display: block;
    font-size: 12px;
    line-height: 1;
    color: #9E9E9E;
    font-weight: 600;

    &.available {
      color: #38b124;
    }
  }
}
</style>